import { createContext, useContext } from 'react';

export interface UserConsentInterface {
  consentForAnalytics: boolean;
}

export const UserConsent = createContext<UserConsentInterface>({ consentForAnalytics: false });

export let userConsentDefaultValue: UserConsentInterface = { consentForAnalytics: false };
export const userConsentSetValue: { current: ((newValue: UserConsentInterface) => void) | null } = {
  current: null,
};

export function setUserConsentProvider(value: UserConsentInterface) {
  if (userConsentSetValue) {
    userConsentSetValue.current?.(value);
  } else {
    userConsentDefaultValue = value;
  }
}

export function useUserConsent() {
  return useContext(UserConsent);
}
